import * as THREE from "three";
import React, { useState, useEffect, useRef, memo } from "react";
import { Text } from '@react-three/drei';
import { SplineSurface, TubeCurve } from "../shape/Spline";
import { Points } from '../shape/Point';

export const MExtrudeSurface = memo(({ vpoints, color, colorHigh, colorSub, offset=null, dirSurface='x', show=true, div=1}) => {
  const objectsSub = [];
  var key = 0;

  if(!vpoints) return null;

  if (offset) {
    vpoints = vpoints.map(v => new THREE.Vector3(v.x+offset.x, v.y+offset.y, v.z+offset.z));
  }

  objectsSub.push(<Points
    key={key}
    vpoints={vpoints.slice(0,3)}
    size={2}
    color={colorSub}
  />)
  key += 1;


  for (let i=0; i<3; i++) {
    const textPosition = new THREE.Vector3(vpoints[i].x, vpoints[i].y+50, vpoints[i].z);

    objectsSub.push( <Text
      key={key}
      position={textPosition}
      rotation={[-Math.PI/2, 0, 0]}
      color='white'
      fontSize={12}
      maxWidth={200} // option
      textAlign='left' // option
      anchorX='left' // option
      anchorY='middle' // option
    >
      SI p{i}
    </Text>);
    key += 1;
  }

  return show ? (
    <>
      <SplineSurface vpoints={vpoints} width={200} color={colorHigh} close={false} div={div} dirSurface={dirSurface}/>
      (objectsSub.length !== 0 ?) && {objectsSub}
    </>
  ) : null;
});


export const MExtrudeSurfaceWithPointIdx = memo(({ vpoints, color, colorHigh, colorSub, offset=null, dirSurface='x', show=true}) => {
  const objects = [];
  var key = 0;
  const width = 200;
  var widthArray = [0, 0, 0];

  if (dirSurface == 'x') {
    widthArray = new THREE.Vector3(width, 0, 0);
  } else if (dirSurface == 'y') {
    widthArray = new THREE.Vector3(0, width, 0);
  } else if (dirSurface == 'z') {
    widthArray = new THREE.Vector3(0, 0, width);
  }
    

  const showVpoints = vpoints.map(v => new THREE.Vector3(v.x+widthArray.x, v.y+widthArray.y, v.z+widthArray.z));

  for (let i = 0; i < showVpoints.length; i++) {
    objects.push(<Text
      key={key}
      position={[showVpoints[i].x+10, showVpoints[i].y, showVpoints[i].z]}
      color='white' // テキストの色を設定します
      fontSize={10} // フォントサイズを設定します
      maxWidth={200} // 最大幅を設定します（オプション）
    >
      p{i}
    </Text>
    );
    key += 1;
  }

  objects.push(<Points
    key={key}
    vpoints={showVpoints}
    size={2}
    color={colorSub}
  />)
  key += 1;

  return show ? (
  <>
    <MExtrudeSurface vpoints={vpoints} color={color} colorHigh={colorHigh} colorSub={colorSub} offset={offset} dirSurface={dirSurface} div={20}/>
    (objects.length !== 0 ?) && {objects}
  </>
  ) : null;
});